import React from 'react';
import ListItemRadioButton from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemRadioButton';
import { ReportSectionTypes } from '../redux/constants';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from '../ReportPage.scss';
const ReportSpamMalwareWarez = ({ onChange, activeTypeMap, onHide })=>{
    return /*#__PURE__*/ React.createElement("ul", {
        className: s['section']
    }, /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.Spam,
        disabled: !activeTypeMap[ReportSectionTypes.Spam],
        label: 'This is spam',
        subLabel: 'This deviation or journal contains third-party advertisement that goes against DeviantArt’s policies',
        onChange: (e)=>onChange(ReportSectionTypes.Spam)
    }), !activeTypeMap[ReportSectionTypes.Spam] && /*#__PURE__*/ React.createElement("span", {
        className: s['reviewed']
    }, "This has been reviewed by staff.", ' ', /*#__PURE__*/ React.createElement("a", {
        onClick: onHide,
        className: "text-link-level-2-primary"
    }, "Hide Content?")), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.Malware,
        disabled: !activeTypeMap[ReportSectionTypes.Malware],
        label: 'This is malware',
        subLabel: 'This deviation download contains a virus, spyware or similar application',
        onChange: (e)=>onChange(ReportSectionTypes.Malware)
    }), !activeTypeMap[ReportSectionTypes.Malware] && /*#__PURE__*/ React.createElement("span", {
        className: s['reviewed']
    }, "This has been reviewed by staff.", ' ', /*#__PURE__*/ React.createElement("a", {
        onClick: onHide,
        className: "text-link-level-2-primary"
    }, "Hide Content?")), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.Warez,
        disabled: !activeTypeMap[ReportSectionTypes.Warez],
        label: 'This is warez',
        subLabel: 'This deviation download contains pirated or illegal copies of software',
        onChange: (e)=>onChange(ReportSectionTypes.Warez)
    }), !activeTypeMap[ReportSectionTypes.Warez] && /*#__PURE__*/ React.createElement("span", {
        className: s['reviewed']
    }, "This has been reviewed by staff.", ' ', /*#__PURE__*/ React.createElement("a", {
        onClick: onHide,
        className: "text-link-level-2-primary"
    }, "Hide Content?")));
};
ReportSpamMalwareWarez.displayName = 'ReportSpamMalwareWarez';
export default ReportSpamMalwareWarez;

//# sourceMappingURL=ReportSpamMalwareWarez.js.map